<template>
  <div
    class="modal fade hl_multiple-users--modal"
    id="multiple-users-modal"
    tabindex="-1"
    role="dialog"
    ref="modalRef"
  >
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-body">
          <div class="modal-body--inner">
            <p class="header">{{ $t('pmd.multipleUsers.chooseAccount') }}</p>
            <div class="form-group">
              <div 
                class="multiple-users--row" 
                v-for="user in values" 
                @click="chooseAgency(user.companyId)" 
                :key="user.companyId"
              >
                <div>
                  <span class="user">{{ user.userName }}</span>
                  <div class="agency">
                    <span>{{ user.agencyName }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onBeforeUnmount, onMounted, ref, watch } from 'vue'



// Define jQuery type
declare const $: any

// Define props
interface Props {
  values?: Array<{
    companyId: string
    userName: string
    agencyName: string
  }> | null
}

const props = defineProps<Props>()

// Define emits
const emit = defineEmits<{
  (e: 'hidden'): void
  (e: 'submit', companyId: string): void
}>()

// Template refs
const modalRef = ref<HTMLElement | null>(null)

// Methods
const chooseAgency = (companyId: string) => {
  emit('submit', companyId)
  $(modalRef.value).modal('hide')
}

// Watchers
watch(() => props.values, (newValues) => {
  if (newValues?.length) {
    $(modalRef.value).modal('show')
  } else {
    $(modalRef.value).modal('hide')
  }
}, { immediate: true })

// Lifecycle hooks
onMounted(() => {
  if (modalRef.value) {
    $(modalRef.value).on('hidden.bs.modal', () => {
      emit('hidden')
    })

    if (props.values?.length) {
      $(modalRef.value).modal('show')
    }
  }
})

onBeforeUnmount(() => {
  if (modalRef.value) {
    $(modalRef.value).off('hidden.bs.modal')
  }
})
</script>

<style lang="scss">
#multiple-users-modal {
  .modal-dialog {
    max-width: 500px !important;
    max-height: 90vh;
    margin: 1.75rem auto;
    display: flex;
    flex-direction: column;
  }
  
  .modal-content {
    display: flex;
    flex-direction: column;
    max-height: 90vh;
    overflow: hidden;
  }
  
  .modal-body {
    flex: 1;
    display: flex;
    flex-direction: column;
    padding: 1rem;
    overflow: hidden;
  }
  
  .modal-body--inner {
    height: 100%;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    width: 100%;
  }
  
  .form-group {
    flex: 1;
    overflow-y: auto;
    overflow-x: hidden;
    min-height: 0;
  }
  
  .multiple-users--row {
    display: flex;
    justify-content: space-between;
    padding: 8px 16px;
    margin-right: 16px;
    margin-left: 16px;
    border-bottom: 1px solid #ced4da;
    
    &:last-child {
      border-bottom: none;
    }
    
    &:hover {
      background-color: #f8f9fa;
      transition: linear 100ms all;
      cursor: pointer;
    }
  }
  .header {
    font-size: 1.5rem;
    font-weight: 500;
    text-align: center;
    margin-bottom: 24px;
  }
  .user {
    font-weight: 400;
    font-size: 1rem;
    user-select: none;
  }
  .agency {
    opacity: 0.87;
    user-select: none;
  }
}
</style>